import { Navigate } from 'react-router-dom';
import Unauthorized from './Unauthorized';
import { useAuth } from '../hooks/useAuth';

export default function RoleProtectedRoute({
    children,
    allowedRoles = [],
    requiredPermissions = [],
}) {
    const { token, roles, permissions } = useAuth();

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // Superadmin has full access
    if (roles.includes('superadmin')) {
        return children;
    }

    if (
        allowedRoles.length > 0 &&
        !allowedRoles.some(r => roles.includes(r))
    ) {
        return <Unauthorized message="Role access denied" />;
    }

    if (
        requiredPermissions.length > 0 &&
        !requiredPermissions.some(p => permissions.includes(p))
    ) {
        return <Unauthorized message="Permission access denied" />;
    }

    return children;
}
